import { render, staticRenderFns } from "./ChinaCity.vue?vue&type=template&id=af2810cc&scoped=true&"
import script from "./ChinaCity.vue?vue&type=script&lang=js&"
export * from "./ChinaCity.vue?vue&type=script&lang=js&"
import style0 from "./ChinaCity.vue?vue&type=style&index=0&id=af2810cc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2810cc",
  null
  
)

export default component.exports